import { ProjectType } from '@lopo-tech/lopo-api'
import React from 'react'
import { RouteComponentProps } from 'react-router'
import { ProjectDetailMapPage } from 'src/pages/project_detail_map'

const InfrastructureProjectDetailMapPage: React.FC<RouteComponentProps> = (props) => (
  <ProjectDetailMapPage {...props} projectType={ProjectType.InfrastructureProject} />
)

export default InfrastructureProjectDetailMapPage
